<template>
  <div>
    <section class="hero-area">
      <div class="hero-shape">
        <img src="@/assets/image/landing-3-shape-2.svg" alt="" class="w-100" />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 order-md-2 order-lg-1">
            <div class="hero-image">
              <img src="@/assets/image/robomarket-mascot.png" width="90%" alt="Mascote do robomarket" />
            </div>
          </div>

          <div class="col-lg-5 offset-lg-1 col-md-6 order-md-1 order-lg-2">
            <div class="hero-left-content">
              <h1>Que tal comprar pelo WhatsApp ou Telegram?</h1>
              <p>
                <b>Clientes: </b>Peça para o Jaiminho que ele irá trazer suas
                compras do Supermercado mais próximo de você! <br /><br />
                <b>Supermercadistas: </b>Ofereça um atendimento automatizado
                para seu supermercado, 24 horas por dia, 7 dias por semana,
                gerando mais eficiência em seu fluxo de atendimento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="feature-section section-padding-top">
      <div class="container">
        <div class="row space-dt--20">
          <div
            class="col-xl-4 col-lg-4 col-md-4 col-sm-6 mt--20"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-once="true"
            data-aos-delay="100"
          >
            <div class="feature-widget">
              <div class="section-title">
                <span>
                  <h2>01</h2>
                </span>
              </div>
              <div class="content">
                <h6 class="title">Cadastre o Supermercado</h6>
                <p>
                  Cadastre o Supermercado e tenha acesso a uma incrível
                  ferramenta de captação de clientes através do maior app de
                  mensageria do Mundo!
                </p>
              </div>
            </div>
          </div>

          <div
            class="col-xl-4 col-lg-4 col-md-4 col-sm-6 mt--20"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <div class="feature-widget">
              <div class="section-title">
                <span>
                  <h2>02</h2>
                </span>
              </div>
              <div class="content">
                <h6 class="title">Divulgue o número do Jaiminho</h6>
                <p>
                  Após feito o cadastro basta divulgar o número do Jaiminho e
                  aguardar os pedidos via WhatsApp.
                </p>
              </div>
            </div>
          </div>

          <div
            class="col-xl-4 col-lg-4 col-md-4 col-sm-6 mt--20"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-once="true"
            data-aos-delay="600"
          >
            <div class="feature-widget">
              <div class="section-title">
                <span>
                  <h2>03</h2>
                </span>
              </div>
              <div class="content">
                <h6 class="title">Os clientes o encontrarão</h6>
                <p>
                  Através da tecnologia de Geolocalização o supermercado mais
                  próximo é disponibilizado para o cliente fazer a sua lista de
                  compras!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="section-divider section-padding-top"></div>
      </div>
    </section>

    <section class="testimonial-section">
      <div class="tstimonial-shape">
        <img src="@/assets/image/landing-3-shape-2.svg" alt class="w-100" />
      </div>
      <div class="container">
        <div id="generic_price_table">
          <section>
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <!--PRICE HEADING START-->
                  <div class="price-heading clearfix">
                    <h1>Planos</h1>
                  </div>
                  <!--//PRICE HEADING END-->
                </div>
              </div>
            </div>
            <div class="container">
              <!--BLOCK ROW START-->
              <div class="row">
                <div
                  class="col-md-4"
                  v-for="plan in plans"
                  :key="plan.shortReason"
                >
                  <!--PRICE CONTENT START-->
                  <div
                    class="generic_content clearfix"
                    :class="{ active: plan.isFeatured }"
                  >
                    <!--HEAD PRICE DETAIL START-->
                    <div class="generic_head_price clearfix">
                      <!--HEAD CONTENT START-->
                      <div class="generic_head_content clearfix">
                        <!--HEAD START-->
                        <div class="head_bg"></div>
                        <div class="head">
                          <span>{{ plan.reason }}</span>
                        </div>
                        <!--//HEAD END-->
                      </div>
                      <!--//HEAD CONTENT END-->

                      <!--PRICE START-->
                      <div class="generic_price_tag clearfix">
                        <span class="price">
                          <span class="sign">R$</span>
                          <span class="currency">{{
                            plan.monthlyFee | showInteger
                          }}</span>
                          <span class="cent"
                            >.{{ plan.monthlyFee | showDecimals }}</span
                          >
                          <span class="month">/Mês</span>
                        </span>
                      </div>
                      <!--//PRICE END-->
                    </div>
                    <!--//HEAD PRICE DETAIL END-->

                    <!--FEATURE LIST START-->
                    <div class="generic_feature_list">
                      <ul>
                        <li>
                          <span>{{
                            plan.maxOrders ? plan.maxOrders : "Sem limite"
                          }}</span>
                          Pedidos/ mês
                        </li>
                        <li>
                          <span>{{
                            plan.maxPickers ? plan.maxPickers : "Sem limite"
                          }}</span>
                          Usuário picking
                        </li>
                        <!-- <li>
                          <span></span> Controle de estoque de produtos
                        </li> -->
                      </ul>
                    </div>
                    <!--//FEATURE LIST END-->

                    <!--BUTTON START-->
                    <div class="generic_price_btn clearfix">
                      <a class @click="selectPlan(plan.shortReason)">Comprar</a>
                    </div>
                    <!--//BUTTON END-->
                  </div>
                  <!--//PRICE CONTENT END-->
                </div>
              </div>
              <!--//BLOCK ROW END-->
            </div>
          </section>
        </div>

        <!-- <div class="masonry-with-columns"> -->
      </div>
    </section>

    <section class="cta-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="cta-content">
              <span class="title-top-text">Vai ficar de fora?</span>
              <h2>Aumente suas vendas com o Jaiminho!</h2>
              <div class="cta-btns">
                <div class="header-btns">
                  <div class="btn-2">
                    <a href="javascript:void(0)" @click="selectPlan('STANDARD')"
                      >Cadastre-se</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { plansCollection } from "@/services/firestore-service";

export default {
  methods: {
    ...mapMutations(["setCurrentPlan"]),
    selectPlan(plan) {
      this.setCurrentPlan(plan);
      this.$router.push("/criar-conta/user");
    },
  },

  filters: {
    showInteger: function (price) {
      let formattedPrice = price.toFixed(2).split(".");
      return formattedPrice[0];
    },

    showDecimals: function (price) {
      let formattedPrice = price.toFixed(2).split(".");
      return formattedPrice[1];
    },
  },

  data() {
    return {
      plans: [],
    };
  },

  mounted() {
    plansCollection.get().then((querySnapshot) => {
      this.$data.plans = [];
      querySnapshot.docs.forEach((docSnapshot, index) => {
        const planData = docSnapshot.data();
        planData.isFeatured = index == 1;
        this.$data.plans.push(planData);
      });
    });
  },
};
</script>

<style scoped>
.feature-widget {
  text-align: center;
}

@media screen and (max-width: 404px) {
  .back-phone {
    width: 234px !important;
    margin-top: -1px;
  }
}

@media screen and (max-width: 321px) {
  .back-phone {
    width: 190px !important;
    height: auto;
  }
}
</style>
